exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie-alert[data-v-1a4f3f76]{font-family:Noto Sans,sans-serif!important;z-index:9999;position:fixed;bottom:15px;width:100%}.gdpr[data-v-1a4f3f76]{border:1px solid #f29a38;font-size:9pt}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a4f3f76","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/CookieAlert.vue
// module id = TAMP
// module chunks = 83